import { fork, call, take, put } from 'redux-saga/effects';
import moment from 'moment';

import { CALENDAR_CHANGE_DATE } from '../actions/calendar/constants';
import { setDate } from '../actions/calendar';

import { updateFilteredDate } from './api/update-filtered-date';

export function* changeDateFlow() {
  while (true) {
    const request = yield take(CALENDAR_CHANGE_DATE);
    const { startDate, endDate } = request.payload;
    const data = yield call(updateFilteredDate, {
      from: startDate.toString(),
      to: endDate.startOf('day').toString(),
    });
    if (data) {
      yield put(setDate(moment(data.start_date), moment(data.end_date)));
    }
  }
}

export default function* calendarSaga() {
  yield fork(changeDateFlow);
}
